import { useTranslation } from 'react-i18next';
import { useInvitationsQuery, useMembersQuery, useResendInvitationMutation, useRevokeInvitationMutation } from '@platform/state/api';
import { useAppDispatch } from '@platform/state/hooks';
import { toastShown } from '@platform/state/slices/uiSlice';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { InvitationRow } from './InvitationRow';
import { InviteForm } from './InviteForm';
import { useMembersSummary } from './useMembersSummary';
import './members.css';

/**
 * «Запрошення» робочого простору (прототип v4 G:L2700–2800, Головна › Учасники › Запрошення): заголовок, «Простір · N учасників · M
 * очікують», форма запрошення за ел. поштою й «Запрошення, що очікують · N» (порожньо — «Немає очікуваних запрошень.») з повторним
 * надсиланням і відкликанням; невдале повторне надсилання — повідомлення.
 */
export function InvitationsPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const { data: members } = useMembersQuery(ws, { skip: !ws });
  const { data } = useInvitationsQuery(ws, { skip: !ws });
  const [revoke] = useRevokeInvitationMutation();
  const [resendInvitation] = useResendInvitationMutation();
  const dispatch = useAppDispatch();
  const resend = (id: string) => resendInvitation({ ws, id }).unwrap()
    .then(() => true, () => { dispatch(toastShown({ kind: 'error', text: t('membersPage.resendFailed') })); return false; });
  const summary = useMembersSummary(ws);
  const pending = (data?.items ?? []).filter((i) => i.status === 'pending');
  return (
    <div className="mb-page">
      <div className="mb-head"><h1>{t('membersPage.invitations')}</h1><span className="muted">{summary}</span></div>
      <InviteForm ws={ws} available={data?.available ?? false} invited={pending.map((i) => i.email.toLowerCase())}
        memberEmails={(members ?? []).map((m) => (m.email ?? '').toLowerCase()).filter(Boolean)} />
      <div className="mb-section">
        <div className="mb-label">{t('membersPage.pendingTitle', { count: pending.length })}</div>
        <div className="mb-list">
          {pending.map((i) => <InvitationRow key={i.id} invitation={i} onResend={resend} onRevoke={(id) => void revoke({ ws, id })} />)}
          {data && !pending.length && <div className="mb-empty">{t('membersPage.noPending')}</div>}
        </div>
      </div>
    </div>
  );
}
